import { ref } from 'vue'

const isSample = ref(false)

export function useSignalSampleMode() {
    function setIsSample(value) {
        isSample.value = value
    }

    return {
        isSample,
        setIsSample,
    }
}
